function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4062 11.1562C12.7514 11.1562 13.0312 10.8589 13.0312 10.4922C13.0312 10.1254 12.7514 9.82812 12.4062 9.82812C12.0611 9.82812 11.7812 10.1254 11.7812 10.4922C11.7812 10.8589 12.0611 11.1562 12.4062 11.1562Z",
  fill: "#1A253B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.875 11.8203H11.9375V14.1445H12.875V11.8203Z",
  fill: "#1A253B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.19531V12.4844H8.84306C9.07347 14.3553 10.5835 15.8047 12.4062 15.8047C14.3878 15.8047 16 14.0918 16 11.9863V1.19531H0ZM12.4062 14.8086C10.9416 14.8086 9.75 13.5425 9.75 11.9863C9.75 10.4301 10.9416 9.16406 12.4062 9.16406C13.8709 9.16406 15.0625 10.4301 15.0625 11.9863C15.0625 13.5425 13.8709 14.8086 12.4062 14.8086ZM15.0625 9.4171C14.4047 8.65008 13.4575 8.16797 12.4062 8.16797C10.5835 8.16797 9.07347 9.61732 8.84306 11.4883H0.9375V2.19141H15.0625V9.4171Z",
  fill: "#1A253B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.125 3.51953H2.1875V10.1602H3.125V3.51953Z",
  fill: "#1A253B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M5 3.51953H4.0625V8.16797H5V3.51953Z",
  fill: "#1A253B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.8125 3.51953H5.9375V8.16797H7.8125V3.51953Z",
  fill: "#1A253B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.6875 3.51953H8.75V8.16797H9.6875V3.51953Z",
  fill: "#1A253B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9375 3.51953H11V8.16797H11.9375V3.51953Z",
  fill: "#1A253B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8125 3.51953H12.875V8.16797H13.8125V3.51953Z",
  fill: "#1A253B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5.9375 9.16406H4.0625V10.1602H5.9375V9.16406Z",
  fill: "#1A253B"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M8.4375 9.16406H6.875V10.1602H8.4375V9.16406Z",
  fill: "#1A253B"
});

function SvgBarCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCode);
export default __webpack_public_path__ + "static/media/bar-code.13b2ff70.svg";
export { ForwardRef as ReactComponent };